import { Controller } from '@hotwired/stimulus'

// Progressive enhancement for a control point's critical-limit fields. Only a
// `between` limit uses both bounds; single-bound comparisons (≤, ≥, <, >, =)
// use one threshold. So Max is shown + required only for `between`, and Min is
// relabelled "limit value" for the single-bound case. The server still
// enforces this (ControlPoint#ccp_must_have_limit) — this is sugar.
export default class extends Controller {
  static targets = ['comparison', 'minField', 'maxField', 'maxInput']
  static values = { minLabel: String, valueLabel: String }

  connect () {
    this.refresh()
  }

  refresh () {
    const between = this.comparisonTarget.value === 'between'

    if (this.hasMaxFieldTarget) this.maxFieldTarget.hidden = !between
    if (this.hasMaxInputTarget) this.maxInputTarget.required = between

    // Bali's `text_group` renders its label as a DaisyUI
    // `<legend class="fieldset-legend">` (no clean target to place on it), so
    // we reach the single legend it renders inside the minField wrapper.
    const minLabel = this.hasMinFieldTarget && this.minFieldTarget.querySelector('.fieldset-legend')
    if (minLabel) minLabel.textContent = between ? this.minLabelValue : this.valueLabelValue
  }
}
